import { Text } from '@chakra-ui/react';
import { Mitopure } from '@time-line/components/icons';

import data from './data.json';

const Title = () => (
  <Text as="h2" size="h2" whiteSpace="pre-wrap">
    <Mitopure color="white" width="135px" /> {data.solution.title}
  </Text>
);

const Description = () => (
  <Text size="body2" position="relative">
    {data.solution.description}
  </Text>
);

export const Solution = { Title, Description };
